export default __webpack_public_path__ + "static/messages-4aacbe064880aafe34501608ae8ca993.png";